import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/identification_types/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/identification_types/?page[size]=100`);
};

const get = async (id) => {
  return await httpClient.get(`/identification_types/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/identification_types/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/identification_types/${id}`);
};

const getByPersonType = async (person_type) => {
  return await httpClient.get(
    `/identification_types/?page[size]=100&filter[tipo_persona]=${person_type}`,
  );
};

export { post, getAll, get, put, remove, getByPersonType };
